import { defineStore } from 'pinia'
import api from '@/utils/api'
import { API_ROUTES } from '@/const/apiRoutes'

const pageSize = 20

export const useApplicantProfileStore = defineStore('applicantProfile', {
  state: (): any => ({ // TODO: add types
    applicantProfiles: [],
    applicantProfile: null,
    loading: false,
    error: null,
    pagination: {
      totalPages: 1,
      currentPage: 1
    },
    filters: {
      type: 'all',
      search: ''
    },
    totalCount: 0
  }),

  getters: {
    hasApplicantProfiles: (state) => state.applicantProfiles.length > 0,
    isPaginated: (state) => state.pagination.totalPages > 1
  },

  actions: {
    async fetchApplicantProfile() {
      this.loading = true
      this.error = null
      try {
        const response = await api.get(API_ROUTES.GET_APPLICANT_PROFILE)
        this.applicantProfile = response.data
      }
      catch (error) {
        console.error('Error fetching applicant profile:', error)
        this.error = 'Failed to fetch applicant profile'
      } finally {
        this.loading = false
      }
    },

    async fetchApplicantProfileById(userId: string | number) {
      this.loading = true
      this.error = null
      try {
        const response = await api.get(API_ROUTES.GET_APPLICANT_PROFILE_BY_USER_ID(userId))
        this.applicantProfile = response.data
      }
      catch (error) {
        console.error('Error fetching applicant profile by ID:', error)
        this.error = 'Failed to fetch applicant profile'
      } finally {
        this.loading = false
      }
    },

    async fetchApplicantProfiles({ page = 1 } = {}) {
      this.loading = true
      this.error = null
      try {
        const params: Record<string, any> = { page, page_size: pageSize }
        
        // Add type filter
        if (this.filters.type !== 'all') {
          params.type = this.filters.type
        }
        
        // Add search if present
        if (this.filters.search) {
          params.search = this.filters.search
        }

        const response = await api.get(API_ROUTES.GET_APPLICANT_PROFILES, { params })
        this.applicantProfiles = response.data.results
        this.totalCount = response.data.count
        this.pagination = {
          totalPages: Math.ceil(response.data.count / pageSize),
          currentPage: page
        }
      } catch (error) {
        console.error('Error fetching applicant profiles:', error)
        this.error = 'Failed to fetch applicant profiles'
      } finally {
        this.loading = false
      }
    },

    async updateReferralPackage(data: { core_referral_text?: string; resume_link?: string; resume_content?: string }) {
      try {
        if (!this.applicantProfile?.referral_package?.id) {
          throw new Error('Referral package ID not found')
        }
        const referralPackageId = this.applicantProfile.referral_package.id
        await api.patch(API_ROUTES.UPDATE_REFERRAL_PACKAGE(referralPackageId), data)
      } catch (error) {
        console.error('Error updating referral package:', error)
        throw error
      }
    }
  }
})